const rest = {
    server: process.env.REACT_APP_REST_SERVER,
    redirectAposCadastro: process.env.REACT_APP_REDIRECT_APOS_CADASTRO,
}

export default rest;
